module.exports = __WEBPACK_EXTERNAL_MODULE__973__;